import React from 'react';

export default function NewAccountCard(props) {
	// console.log('NewAccountCard', props);
	return (
		<div className="NewAccountCard p-2 mx-auto d-inline-block h-100">
			<div className="card border h-100">
				<div className="card-body w-100 mx-auto text-center px-4">
					<h1 className="card-title mx-auto mx-4">
						{I18n.t('admin.create_new_account_title')}
					</h1>
					<hr />
					<span className="mb-3 d-block">
						{I18n.t('admin.create_new_account_instructions')}
					</span>
					<button
						type="button"
						className="btn btn-primary w-100 mt-2"
						onClick={() => {
							props.onHidePopup();
							props.onShowPopup();
						}}
					>
						{I18n.t('admin.create_new_account')}
					</button>
				</div>
			</div>
		</div>
	);
}
